import { type GridColDef } from "@mui/x-data-grid";

import { Translation } from "@/data/lang";
import { renderCell } from "@/features/analysis/utils/data-grid-renderer";

export const getBuyingInfoCols = ({
  t,
  isBlocked,
}: {
  t: Translation;
  isBlocked: boolean;
}): GridColDef[] => [
  {
    field: "filingAt",
    headerName: t.analysis.chip.insider.fillingAt,
    description: t.analysis.chip.insider.fillingAt,
    headerAlign: "left",
    align: "left",
    flex: 1,
    minWidth: 120,
  },
  {
    field: "buyerName",
    headerName: t.analysis.chip.insider.buyerName,
    description: t.analysis.chip.insider.buyerName,
    headerAlign: "left",
    align: "left",
    flex: 1,
    minWidth: 155,
  },
  {
    field: "buyerTitle",
    headerName: t.analysis.chip.insider.buyerTitle,
    description: t.analysis.chip.insider.buyerTitle,
    headerAlign: "left",
    align: "left",
    flex: 1,
    minWidth: 85,
  },
  {
    field: "tradeAt",
    headerName: t.analysis.chip.insider.tradeAt,
    description: t.analysis.chip.insider.tradeAt,
    headerAlign: "center",
    align: "center",
    flex: 1,
    minWidth: 125,
  },
  {
    field: "tradeCash",
    headerName: t.analysis.chip.insider.tradingAmount,
    description: t.analysis.chip.insider.tradingAmount,
    headerAlign: isBlocked ? "center" : "right",
    align: isBlocked ? "center" : "right",
    renderCell: renderCell({
      formatter: (value) => `$${value}`,
    }),
    flex: 1,
    minWidth: 95,
  },
  {
    field: "tradeNum",
    headerName: t.analysis.chip.insider.tradingShares,
    description: t.analysis.chip.insider.tradingShares,
    headerAlign: isBlocked ? "center" : "right",
    align: isBlocked ? "center" : "right",
    renderCell: renderCell({
      showRiseFallColor: true,
    }),
    flex: 1,
    minWidth: 85,
  },
  {
    field: "tradeNumAfter",
    headerName: t.analysis.chip.insider.tradeNumAfter,
    description: t.analysis.chip.insider.tradeNumAfter,
    headerAlign: isBlocked ? "center" : "right",
    align: isBlocked ? "center" : "right",
    renderCell: renderCell(),
    flex: 1,
    minWidth: 120,
  },
  {
    field: "stockCategory",
    headerName: t.analysis.chip.insider.stockCategory,
    description: t.analysis.chip.insider.stockCategory,
    headerAlign: "left",
    align: "left",
    flex: 1,
    minWidth: 110,
  },
];
